import { colors, fontFamily } from '@atlaskit/theme';
import React, { MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { messages } from '../messages';
import { BlankPointerImage } from './blank-pointer-image';

export type EmptyViewProps = {
  readonly getStartedUrl: string;
  readonly onGetStartedClick?: MouseEventHandler;
};

export function EmptyView({
  getStartedUrl,
  onGetStartedClick
}: EmptyViewProps) {
  return (
    <Container>
      <BlankPointerImage />
      <Link
        href={getStartedUrl}
        onClick={(event) => {
          if (onGetStartedClick) {
            onGetStartedClick(event);
          }
        }}
      >
        <FormattedMessage {...messages.getStarted} />
      </Link>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 27px;
`;

const Link = styled.a`
  margin: 15px 15px 0;

  color: ${colors.B400};
  text-decoration: none;
  cursor: pointer;
  font-family: ${fontFamily};
  font-size: 12px;
  line-height: 14px;
  text-align: center;
`;
